import { useMemo } from 'react'
import { useThree } from '@react-three/fiber'
import { OrbitControls } from '@react-three/drei'
import { Vector3 } from 'three'

const Controls = function (props: any) {
  const { camera, gl } = useThree()
  const target = useMemo(() => {
    if (Array.isArray(props.target)) {
      return new Vector3(props.target[0], props.target[1], props.target[2])
    }
    if (props.target instanceof Vector3) {
      return props.target
    }
    return undefined
  }, [props.target])

  const hasLookAt = !!camera && typeof (camera as { lookAt?: unknown }).lookAt === 'function'
  if (!hasLookAt) {
    return null
  }

  return (
    <OrbitControls
      makeDefault
      args={[camera, gl.domElement]}
      target={target}
      {...props}
    />
  )
}

export default Controls
